import { cronToParts, DAY_NAMES } from './cronParts.js'

const at = (parts) =>
  `${String(parts.hour).padStart(2, '0')}:${String(parts.minute).padStart(2, '0')}`

const plural = (n, word) => `${n} ${word}${n === 1 ? '' : 's'}`

const dayList = (weekdays) => {
  const names = weekdays.map((day) => DAY_NAMES[day])
  if (names.length === 1) return names[0]
  return `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`
}

/**
 * A schedule as something a person can read. Never returns a cron expression:
 * users are not asked to understand cron anywhere in this product, so a shape we
 * cannot describe becomes the honest, non-committal "Custom schedule" rather
 * than a raw string or — worse — a confident mistranslation.
 */
export function cronLabel(cron, timezone) {
  const parts = cronToParts(cron)
  const suffix = timezone ? ` (${timezone})` : ''

  switch (parts.repeat) {
    case 'custom':
      return `Every ${plural(parts.every, parts.unit === 'hours' ? 'hour' : 'minute')}${suffix}`
    case 'hourly':
      return `Every hour at :${String(parts.minute).padStart(2, '0')}${suffix}`
    case 'daily':
      return `Every day at ${at(parts)}${suffix}`
    case 'weekdays':
      return `Every weekday at ${at(parts)}${suffix}`
    case 'weekly':
      return `Every ${dayList(parts.weekdays)} at ${at(parts)}${suffix}`
    case 'monthly':
      return `Day ${parts.dayOfMonth} of each month at ${at(parts)}${suffix}`
    default:
      return 'Custom schedule'
  }
}
